import {
  ActionIcon,
  Box,
  Button,
  Divider,
  Flex,
  Group,
  Tooltip,
  Image,
  Text,
  Stack,
  Loader,
} from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { MeterReturnType } from "../../types";
import useMeterDetails from "../../hooks/useMeterDetails";
import { formatDate, getYearMonth } from "../../utils/date";
import { useMeterStore } from "../../store/meter.store";
import { METER_SIDEBAR_SELECTOR } from "../../constants";

type MeterDetailsViewProps = {
  meter: MeterReturnType;
  closeSidebar: () => void
};

export default function MeterDetailsView({ meter, closeSidebar }: MeterDetailsViewProps) {
  const { setMeterSidebarSelector } = useMeterStore((state) => state);
  
  const { meterDetails, loading } = useMeterDetails(meter?.meterSerialNo);

  return (
    <Box>
      <Group justify="flex-end">
        <Tooltip label={"Close"}>
          <ActionIcon color="pink" size={"sm"} onClick={closeSidebar}>
            <IconX />
          </ActionIcon>
        </Tooltip>
      </Group>

      <Group justify="space-between">
        <Image
          src={"../assets/images/tap-icon.png"}
          alt="tap"
          width={50}
          height={50}
        />
        <Flex direction={"column"} align={"flex-end"}>
          <Text size="lg" fw={600} c={"dimmed"}>
            M/s: {meter?.meterSerialNo}
          </Text>
          <Button
            size="xs"
            c={"black"}
            px={10}
            py={0}
            w={"fit-content"}
            variant="outline"
            style={{ borderColor: "black" }}
            onClick={() => {
              setMeterSidebarSelector(
                METER_SIDEBAR_SELECTOR.meterPayloadDetails,
                METER_SIDEBAR_SELECTOR.meterDetails
              );
            }}
          >
            All data
          </Button>
        </Flex>
      </Group>
      <Divider my={"md"} size={"md"} color="darkblue" />
      {loading ? (
        <Group justify="center" my={"md"}>
          <Loader size={"sm"} />
          <Text>Loading...</Text>
        </Group>
      ) : !meterDetails ? (
        <Text ta={"center"} my={"md"} fw={600}>
          No data found.
        </Text>
      ) : (
        <>
          <Group align="flex-start">
            <Box flex={0.7}>
              <Stack>
                <Box>
                  <Text size="sm" fw={600}>
                    MSISDN
                  </Text>
                  <Text size="xs">{meterDetails?.MSISDN}</Text>
                </Box>
                <Box>
                  <Text size="sm" fw={600}>
                    Date of installation
                  </Text>
                  <Text size="xs">{formatDate(meterDetails?.createdAt)}</Text>
                </Box>
                <Box>
                  <Text size="sm" fw={600}>
                    Year & Month of Expiry
                  </Text>
                  <Text size="xs">{getYearMonth(meterDetails?.EXP_year)}</Text>
                </Box>
                {meterDetails?.More_details ? (
                  <Box>
                    <Text size="sm" fw={600}>
                      More Details
                    </Text>
                    <Text size="xs">{meterDetails?.More_details}</Text>
                  </Box>
                ) : null}
                <Box>
                  <Text size="sm" fw={600}>
                    Tariff
                  </Text>
                  <Text size="xs">{meterDetails?.tariff ?? "--"}</Text>
                </Box>
                <Box>
                  <Text size="sm" fw={600}>
                    TRANSMIT TO WRA
                  </Text>
                  <Text size="xs">{meterDetails?.wra ? "Yes" : "No"}</Text>
                </Box>
                {meterDetails?.location ? (
                  <Box>
                    <Text size="sm" fw={600}>
                      COORDINATES INSTALLED
                    </Text>
                    <Text size="xs">{meterDetails?.location}</Text>
                  </Box>
                ) : null}
              </Stack>
            </Box>
            <Box flex={0.3}>
              <Stack>
                <Box>
                  <Text size="sm" fw={600}>
                    Model
                  </Text>
                  <Text size="xs">{meterDetails?.model}</Text>
                </Box>
                <Box>
                  <Text size="sm" fw={600}>
                    Meter Size
                  </Text>
                  <Text size="xs">{meterDetails?.meterSize ?? "--"}</Text>
                </Box>
              </Stack>
            </Box>
          </Group>
          <Divider my={"md"} size={"md"} color="darkblue" />
        </>
      )}
    </Box>
  );
}
